export default __webpack_public_path__ + "static/media/imerza-diamond-alt.623f6463.png";